export default "__VITE_ASSET__BckgR7Im__"